define([
	"dojo/_base/declare",
	"csi/util"
], function(declare,util) {

	return declare(null, {
		// Boolean: indicates if first result should be selected by default
		bSelectFirst: false,

		// String: the view to switch based on selection
		idContentView: null,

		_initSwitchboard: function(def) {
			this.bSelectFirst = (util.getProperty(def, "Select") == "1");
			this.idContentView = util.getProperty(def, "ContentId");
		}
	});
});